<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">商品选择</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body" style="padding:20px;height: 500px;">
                <el-form :model="searchGoodsForm" inline ref="searchGoodsForm">
                    <el-form-item>
                        <el-input  placeholder="请输入商品名称" v-model.trim="searchGoodsForm.name" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-cascader
                                v-model="searchGoodsForm.goodsClassGovernmentCode"
                                :options="goodsClassGovValue"
                                :props="options" clearable placeholder="请选择商品属性分类" ></el-cascader>
                    </el-form-item>
                    <el-button  type="primary" icon="el-icon-search" @click="getGoodsList(true)">查询</el-button>
                </el-form>
                <el-table ref="goodsTable" :header-cell-class-name="cellClass" v-loading='loading'
                          :data="goodsTable" height="380" border row-key="goodsCode"
                          @selection-change="selectionChange" @select='select'>

                    <el-table-column type="selection" width="80"
                    align="center"
                    :reserve-selection="true"></el-table-column>

                    <el-table-column prop="name" label="标题" min-width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="nameMore" label="副标题" min-width="250" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="goodsClassGovernmentName" min-width="150" label="商品分类"></el-table-column>
                    <el-table-column label="价格/库存" min-width="100">
                        <template slot-scope="scope">
                            <el-button type="primary" plain size="small" @click="handlePrice(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stock" label="总库存"></el-table-column>
                    <el-table-column label="特价">
                        <template slot-scope="scope">
                            <el-tag v-show="scope.row.isBargainPrice==1" type="danger">否</el-tag>
                            <el-tag v-show="scope.row.isBargainPrice==2">是</el-tag>
                        </template>
                    </el-table-column>

                    <!-- <el-table-column prop="createTime" :formatter="timefilter1" width="200" label="创建时间"></el-table-column> -->

                </el-table>
                <el-pagination
                    @current-change="getGoodsList"
                    :current-page.sync="goodsCurrentPage"
                    :page-size="goodsPageSize"
                    background
                    layout="total, prev, pager, next"
                    :total="goodsTotal"
                    style="margin-top:15px">
                </el-pagination>
            </div>
        </div>

        <!-- <AddOrder ref="myAddOrder" v-show="showModalAddOrder" v-on:closeAddOrder="closeAddOrder"></AddOrder> -->
        <el-dialog
            title="商品价格/库存"
            :visible.sync="showModalPrice"
            center
            :close-on-click-modal='false'
            :show-close='showClose'
            top='30vh'
            width="600px" :modal-append-to-body='false'>
            <template>
                <el-table
                    :data="goodsPriceDTOList"
                    :span-method="arraySpanMethods"
                    border
                    height="350"
                    v-if="goodsPriceDTOList.length>0"
                    style="width: 100%">
                    <el-table-column
                        v-if="goodsPriceDTOList[0].goodsColorName"
                        prop="goodsColorName"
                        label="颜色">
                    </el-table-column>
                    <el-table-column
                        v-if="goodsPriceDTOList[0].goodsSizeName"
                        prop="goodsSizeName"
                        label="尺寸">
                    </el-table-column>
                    <el-table-column
                        prop="price"
                        label="单价（元）">
                    </el-table-column>
                    <el-table-column
                        prop="stock"
                        label="库存">
                    </el-table-column>
                    <el-table-column label="操作" min-width="100">
                        <template slot-scope="scope">
                            <el-button type="primary" plain size="small" @click="handleAdd(scope.row)">加购</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </el-dialog>
    </div>

</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    // import AddOrder from "./AddOrder"

    export default {
        name: 'GetGood',
        props:['goodsClassGovValue'],
        data() {
            return {
                showModalAddOrder:false,
                showModalPrice:false,
                loading: false,
                showClose: true,
                elderly:'',
                totalItems:0,
                pageSize:20,
                pageIndex:1,
                elderlyCode:'',
                goodsCurrentPage:1,
                goodsPageSize:20,
                goodsTotal:0,
                searchGoodsForm:{
                    name:'',
                    goodsClassGovernmentCode:'',
                },
                options:{
                    value:'goodsClassCode',
                    label:'name',
                    children:'goodsClassGovernmentList',
                    emitPath:false
                },
                goodsTable:[],
                goodsSelection:[],
                goodsPriceDTOList:[],
                selectData:null
            }
        },
        components:{
            // AddOrder
        },
        methods: {
            init(refresh){
                this.$refs.goodsTable.clearSelection();
                if(refresh.length>0){
                    refresh.forEach(row => {
                        this.$refs.goodsTable.toggleRowSelection(row);
                    });
                }
                // this.goodsSelection=refresh
                this.getGoodsList()
            },
            handlePrice(row){
                this.selectData=row
                this.goodsPriceDTOList=row.goodsPriceDTOList
                this.goodsPriceDTOList.sort(this.compare('goodsColorName'))
                this.showModalPrice=true
            },
            compare(property) {
                return function (a, b) {
                    var value1 = a[property];
                    var value2 = b[property];
                    return value1.localeCompare(value2);
                }
            },
            closeSelf() {
                this.$emit("closeGetGoods");
                this.$emit("selectionChange",this.goodsSelection);
            },
            handleAdd(row){
                this.showClose=true
                this.getGoodsSelection(row)
                this.showModalPrice=!this.showModalPrice
            },
            getGoodsSelection(row){
                var index=0
                this.goodsSelection.forEach(element => {
                    if(element.goodsCode==row.goodsCode){
                        element.goodsPriceDTOList=[row]
                        index++
                    }
                })
                if(index==0){
                    this.$refs.goodsTable.toggleRowSelection(this.selectData);
                    this.getGoodsSelection(row)
                }
            },
            handleAddOrder(index, row) {
                this.$refs.myAddOrder.init(row,this.elderlyCode);
                this.showModalAddOrder = !this.showModalAddOrder;
            },
            cellClass(row){
                if (row.columnIndex === 0) {
                    return 'disabledCheck'
                }
            },
            closeAddOrder:function(){
                this.showModalAddOrder = !this.showModalAddOrder;
            },
            selectionChange(val){
                val.forEach(element => {
                    this.goodsSelection.forEach(element1 => {
                        if(element.goodsCode==element1.goodsCode){
                            element=element1
                        }
                    })
                });
                this.goodsSelection=val
            },
            select(selection,row){
                selection.forEach(element=>{
                    if(row.goodsCode==element.goodsCode){
                        this.handlePrice(row)
                        this.showClose=false
                    }
                })
            },
            getGoodsList(isSearch){
                if(typeof isSearch =='boolean'&&isSearch)this.goodsCurrentPage=1
                this.loading=true
                var data={
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    staffCode: getStaffCode(),
                    pageIndex:this.goodsCurrentPage,
                    pageSize:this.goodsPageSize
                }
                Object.assign(data,this.searchGoodsForm)
                if(!data.goodsClassGovernmentCode)data.goodsClassGovernmentCode='00000000-0000-0000-0000-000000000000'
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Goods/PageForGovAll",
                    data:data
                }).then(
                    (response) => {
                        this.loading=false
                        if (response.data.error == 0) {
                            this.goodsTable=response.data.data.list;
                            this.goodsTotal=response.data.data.total;
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,0);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 1000px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px;
                z-index: 99;
                height:700px;

                /deep/ .el-table .disabledCheck .cell .el-checkbox__inner{
                    display: none !important;
                }

                /deep/ .el-table .disabledCheck .cell::before{
                    content: '选择';
                    text-align: center;
                    line-height: 20px;
                }
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }

            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
